import React from 'react';

const CallbackPage = () => {
  return <div></div>;
};

export default CallbackPage;
